// export { default } from "./Login";

import Login from "./Login";

export default Login;